<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Editar Salida&nbsp
              |
              a.button.is-black.is-rounded(@click="backSalidas")
                i.fas.fa-times
        .columns
          .column.is-12
            FormEditar(:salida="combustible_salidaSelect" @saveForm="saveForm")
        .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBarTransportes.vue'
  import FormEditar from './componentes/FormEditar.vue'
  import Loader from '@/components/shared/Loader.vue'
  import InventarioServices from '@/services/inventario/inventario'
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'EditarSalida',
    components: { NavBar, Loader, FormEditar },
    data() {
      return {
        isLoading: true,
      }
    },
    methods: {
      iniciarComponente () {
        this.isLoading = false
      },
      backSalidas() {
        this.$store.commit('seleccionarSalidaComb', {})
        this.$router.push('/Transportes/Combustible/Salidas')
      },
      saveForm(data) {
        console.log(data)
        InventarioServices.editarSalidaComb(id, fechaSalida, cargaP, cargaL, kmActual)
          .then((data)=> {
            console.log(data)
          })
          .catch((e)=> console.log(e))

      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'combustible_salidaSelect'])
    }
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/EditarSalida.vue